import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { TbShoppingBag } from "react-icons/tb";
import './Product.css';
import { useDispatch, useSelector } from "react-redux";
import {addToCart,removeFromCart, setCart,  setTotalItems,setTotalPrice,setCartId,} from "../../store/cartSlice";
import { getWithoutTokenAPI, postWithTokenAPI } from "../../util/Api";
import ProductCardpop from "../Product-quick-view/quickview";
import "../../Components/ProductCard/FeaturedProducts.css";
import LoginPopup from "../Loginpopup/Loginpop";
import { AiOutlineEye } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactStars from "react-rating-stars-component";
  import AOS from 'aos';
import 'aos/dist/aos.css';
import { addToWishlist, removeFromWishlist, incrementWishlistCount, decrementWishlistCount } from "../../store/wishlistSlice";


const FeaturedProducts = ({ product }) => {
  



    const [productList, setProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
    const [error, setError] = useState(null);
    const [addingToCart, setAddingToCart] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [productData, setProductData] = useState([]);
    const [isLiked, setIsLiked] = useState(false);

    const accessToken = useSelector((state) => state.auth?.auth?.access_token);
    const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
    const userId = useSelector((state) => state.auth?.auth?._id);
    const wishlistItems = useSelector((state) => state.wishlist.items);
    useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);

    // useEffect(() => {
    //     const fetchProducts = async () => {
    //         try {
    //             const queryParams = userId ?`?user_id=${userId}` : '';
    //             const response = await getWithoutTokenAPI(`/product/find-all${queryParams}`);
    //             if (response?.statusCode === 200) {
    //                 let products = response.data?.Product || [];

    //                 if (isLoggedIn && wishlistItems) {
    //                     products = products.map((product) => ({
    //                         ...product,
    //                         sellerName: product.seller_id?.name || "Unknown Seller",
    //                         wish_status: wishlistItems.some(item => item._id === product._id) || product.wish_status || false
    //                     }));
    //                 } else {
    //                     products = products.map((product) => ({
    //                         ...product,
    //                         sellerName: product.seller_id?.name || "Unknown Seller",
    //                         wish_status: product.wish_status || false
    //                     }));
    //                 }
    //                 setProductList(products);
    //             }
    //         } catch (error) {
    //             console.error("Failed to fetch products:", error);
    //         }
    //     };

    //     fetchProducts();
    // }, [userId, isLoggedIn, wishlistItems]);
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const queryParams = userId ? `?user_id=${userId}` : '';
      const response = await getWithoutTokenAPI(`/product/find-all${queryParams}`);

      if (response?.statusCode === 200) {
        let products = (response.data?.Product || []).filter(
          (product) => product.Approval_status === "Approval"
        );

        if (isLoggedIn && wishlistItems) {
          products = products.map((product) => ({
            ...product,
            sellerName: product.seller_id?.name || "Unknown Seller",
            wish_status: wishlistItems.some(item => item._id === product._id) || product.wish_status || false
          }));
        } else {
          products = products.map((product) => ({
            ...product,
            sellerName: product.seller_id?.name || "Unknown Seller",
            wish_status: product.wish_status || false
          }));
        }

        setProductList(products);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };

  fetchProducts();
}, [userId, isLoggedIn, wishlistItems]);

    const openPopup = async (_id) => {
        if (!_id) return;

        try {
            // Only append user_id if it exists
            const queryParams = userId ? `&user_id=${userId}` : '';
            const response = await getWithoutTokenAPI(`/product/find-particular?_id=${_id}${queryParams}`);
            if (response && response.statusCode === 200 && response.data) {
                // Always add sellerName property for popup
                // console.log("wish",response.data.wish_status);
                // console.log("tag",response.data);
                const productWithSeller = {
                    ...response.data,
                    sellerName: response.data.seller_id?.name || "Unknown Seller",
                    wish_status: response.data.wish_status
                };
                setSelectedProduct(productWithSeller);
                setIsPopupOpen(true);
            } else {
                console.warn("Product not found or bad response:", response);
            }
        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setSelectedProduct(null);
        // fetchProducts();
    };

    const handleWishlistClick = async (e, product) => {
        e.stopPropagation();

        if (!isLoggedIn || !accessToken) {
            setLoginPopupOpen(true);
            return;
        }

        try {
            const payload = {
                product_id: product._id,
                category_id: product.category_id || product.category?._id,
            };

            const response = await postWithTokenAPI(accessToken, "/wishlist/add", payload);

            if (response?.statusCode === 200) {
                // Update the product's wish_status in the productList
                setProductList(prevList => 
                    prevList.map(p => 
                        p._id === product._id 
                          ? { ...p, wish_status: true }
                          : p
                      )
                );
                dispatch(addToWishlist(product));
                dispatch(incrementWishlistCount());
                toast.success('Item added to wishlist successfully!');
            } else if (response?.statusCode === 406) {
                // Update the product's wish_status in the productList
                setProductList(prevList => 
                    prevList.map(p => 
                        p._id === product._id 
                            ? { ...p, wish_status: false }
                            : p
                    )
                );
                dispatch(removeFromWishlist(product._id));
                toast.success('Item removed from wishlist');
            } else {
                console.warn("Failed to update wishlist:", response);
                toast.error('Failed to update wishlist');
            }
        } catch (error) {
            console.error("Error updating wishlist:", error);
            toast.error('Error updating wishlist');
        }
    };

 

    const handleAddToCart = async (cartItem) => {
        if (!accessToken) {
          setLoginPopupOpen(true);
          return;
        }
        if (!cartItem?._id) return;
    
        if (addingToCart) return;
        setAddingToCart(true);
        setError(null);
    
        try {
          const payload = {
            cart: [
              {
                product_id: cartItem._id,
                quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
              },
            ],
          };
        //   console.log(payload);
    
          const response = await postWithTokenAPI(accessToken, "/cart/add", payload);
    
          // 🧹 Case: Cart emptied
          if (
            response?.statusCode === 200 &&
            response?.message === "Product removed and cart deleted as it became empty"
          ) {
            dispatch(setCart([]));
            dispatch(setTotalItems(0));
            dispatch(setTotalPrice(0));
            dispatch(setCartId(null));
            toast.info("Item removed and cart is now empty.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              toastId: `removed-${cartItem._id}`,
              theme: "light",
            });
          }
    
          // ✅ Case: Product added successfully
          else if (response?.statusCode === 200 && response.data?.cart) {
            const addedItem = response.data.cart;
    
            dispatch(
              addToCart({
                id: addedItem.product_id,
                price: addedItem.price,
                quantity: addedItem.quantity,
                name: addedItem.name,
                image: addedItem.image,
              })
            );
    
            toast.success("Item added to cart successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              toastId: `cart-${cartItem._id}`,
              theme: "light",
            });
          }
    
          // ❌ Failure case
          else {
            toast.error("Failed to add item to cart.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              toastId: `error-${cartItem._id}`,
              theme: "light",
            });
          }
        } catch (error) {
          console.error("Add to cart error:", error);
          toast.error("Something went wrong. Please try again.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            toastId: `error-${cartItem._id}`,
            theme: "light",
          });
        } finally {
          setAddingToCart(false);
        }
      };
    const closeLoginPopup = () => {
        setLoginPopupOpen(false);
    };
    const toggleLike = () => {
        setIsLiked(!isLiked);
    };

    const starRatingConfig = {
        size: 20,
        value: 0,
        edit: false,
        activeColor: "#ffd700",
        color: "#d4d4d4",
        isHalf: true,
        count: 5,
        a11y: true,
        onChange: () => { },
        classNames: {
            container: "star-rating-container",
            star: "star-rating-star"
        }
    };

    return (
        <>
            {/* <ToastContainer /> */}
            {/* <Helmet>
                <title>{productList.name ? `${productList.name}'s Product` : 'Product'}</title>
                < meta name="description" content="Specific Product page" />
            </Helmet> */}
            {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}
            <div className="container-fluid my-5 featured-products-section product-content-position p-md-5">
                {productList.length > 0 && (
                    <>
                <h6 className="text-center ff-poppins fs-14 fw-500 fc-green category-title "
                  data-aos="fade-down">
                    Products
                </h6>
                <h2 className=" ff-poppins fs-36 fw-600 category-title-2 " data-aos="zoom-in">
                    Our Featured Products
                </h2>
                </>
                )}

                <div className="row">
             

                    <div className="col-lg-12 col-md-12 mt-3">
                        {/* <div className="row row-cols-2 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 g-3"
                        > */}
                        {productList.length > 7 && (
  <div className="text-end mb-3" data-aos="fade-left">
               <button
   className="btn custom-view-btn ff-poppins fw-600 fs-14"
   onClick={() => navigate("/shop")}
   data-aos="fade-left"
   data-aos-delay="300"
 >
   View All <FaArrowRightLong className="ms-2" />
 </button>
  </div>
)}

                        <div className="row custom-row-cols-5 g-3">


                            {productList.slice(0, 7).map((product, index) => {
                                  const animations = ['fade-up', 'fade-down', 'fade-right', 'fade-left', 'zoom-in', 'flip-left', 'flip-up'];
  const animationType = animations[index % animations.length];
                                const isInWishlist = product.wish_status;
                                const image = product.product_image?.[0];
                                const name = product.name;
                                const price = typeof product.discount_price === 'number' ? product.discount_price : 0;

                                return (
                                    <div
                                        className="col"
                                        key={product._id || index}
                                    >
                                        <div
                                            className={`product-card-first${isInWishlist ? ' wishlist-active' : ''}`}
                                            onClick={() => navigate(`/product?_id=${product._id}&seller_name=${product.sellerName}&product_name=${name}&wish_status=${product.wish_status || false}`)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="product-card-first__image">
                                                {image ? (
                                                    <img src={image} alt={name} className="first-image" />
                                                )
                                                    : (
                                                        <p>No Image</p>
                                                    )}

                                                <div className="product-card-first__actions" onClick={(e) => e.stopPropagation()}>
                                                    <div
                                                        className={`action-btn ${isInWishlist ? 'wishlist-active' : ''}`}
                                                        title="Wishlist"
                                                        onClick={(e) => handleWishlistClick(e, product)}
                                                        style={{
                                                            background: "white",
                                                            border: "1px solid #e6e6e6",
                                                            borderRadius: "50%",
                                                            padding: "6px",
                                                            width: "32px",
                                                            height: "32px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                            transition: "all 0.3s ease"
                                                        }}
                                                    >
                                                        {isInWishlist ? (
                                                            <FaHeart style={{ color: '#00b207', fontSize: '16px' }} />
                                                        ) : (
                                                            <FaRegHeart style={{ color: '#1a1a1a', fontSize: '16px' }} />
                                                        )}
                                                    </div>

                                                    <div
                                                        className="action-btn action-btn--eye"
                                                        title="Quick View"
                                                        onClick={() => openPopup(product._id)}
                                                        style={{
                                                            background: "white",
                                                            border: "1px solid #e6e6e6",
                                                            borderRadius: "50%",
                                                            padding: "6px",
                                                            width: "32px",
                                                            height: "32px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                            transition: "all 0.3s ease"
                                                        }}
                                                    >
                                                        <AiOutlineEye size={16} style={{ color: "black" }} />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="product-card-first__info mt-1">
                                                <div className="product-card-first__title">{name}</div>

                                                <span
                                                    className="ff-poppins fs-12"
                                                    style={{ color: "#00b207" }}
                                                >
                                                    {product.sellerName}
                                                </span>
                                                <div className="product-card-first__price">Ksh {price.toFixed(2)}</div>
                                                <div className="product-card-first__review">
                                                    <ReactStars
                                                        {...starRatingConfig}
                                                        value={product.average_rating || 0}
                                                        key={`stars-${product.average_rating}`}
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className="product-card-first__add-to-cart"
                                                title="Add to Cart"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddToCart({ ...product, quantity: 1 });

                                                }}
                                            >
                                                <TbShoppingBag size={20} className="bag" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        

                        </div>
                    </div>
                </div>

                {isPopupOpen && selectedProduct && (
                    <ProductCardpop
                        isOpen={isPopupOpen}
                        onClose={closePopup}
                        selectedProductId={selectedProduct._id}
                        productDetails={selectedProduct}
                    />
                )}
            </div>
        </>
    );
};

export default FeaturedProducts;